module.exports = __webpack_public_path__ + "static/media/silestone-white.e445d49a.svg";